import aniketImg from "../Assets/About/Aniket.jpeg";
import mridulImg from "../Assets/About/Mridul.jpeg";
import somojitImg from "../Assets/About/somojit.jpeg";
import debdityaImg from "../Assets/About/Debditya.jpeg";
import rishikeshImg from "../Assets/About/Rishikesh.jpeg";
import tm1 from "../Assets/About/tm_1.avif";
import tm2 from "../Assets/About/tm_2.avif";
import tm3 from "../Assets/About/tm_3.jpg";
import tm4 from "../Assets/About/tm_4.jpg";

export const teamMembers = [
  {
    name: "Soumyajit Hui",
    position: "Founder, CEO",
    executive: true,
    modal: true,
    img: somojitImg,
    showLinkdin: true,
    linkedInUrl: "https://www.linkedin.com/in/soumyajit-hui-813a52238/",
    shortDesc:
      "Leads the AI vision at Labops, redefining how healthcare operates in India.",
    longDesc:
      "As the visionary founder of Labops, Soumyajit leads the charge in reimagining the healthcare ecosystem in India. With a strong foundation in AI and product thinking, he ensures that every decision aligns with the company’s long-term mission. He’s actively involved in strategic partnerships, R&D, and shaping Labops into an intelligent healthcare engine for the future.",
    experienceYears: "2023",
  },
  {
    name: "Debditya Mallick",
    position: "Founder, COO",
    executive: true,
    modal: true,
    img: debdityaImg,
    showLinkdin: true,
    linkedInUrl: "https://www.linkedin.com/in/debditya-mallick-940779250/",
    shortDesc:
      "Heads internal ops and systems to keep Labops execution streamlined.",
    longDesc:
      "Debditya manages operations, strategy, and internal systems at Labops. He brings calm, clarity, and structure to the fast-moving nature of AI and health tech. From daily workflows to product scalability, Deb ensures the backend of Labops functions like clockwork, enabling teams to innovate fearlessly.",
    experienceYears: "2023",
  },
  {
    name: "Aniket Verma",
    position: "Backend Engineer",
    img: aniketImg,
    modal: true,
    linkedInUrl: "https://www.linkedin.com/in/aniketverma11/",
    shortDesc:
      "Crafts reliable backend services that fuel Labops’ healthcare AI stack.",
    longDesc:
      "Aniket plays a key role in engineering the backbone of Labops’ AI-powered infrastructure. He works on building secure, scalable APIs and robust service layers, ensuring every system is performant and resilient under load. He’s passionate about system design and continuously improving backend architecture.",
    experienceYears: "2024",
  },
  {
    name: "Mridul Singhal",
    position: "Backend Engineer",
    img: mridulImg,
    modal: true,
    linkedInUrl: "https://www.linkedin.com/in/mridul-singhal-44aa62202/",
    shortDesc:
      "Works on Labops’ scalable data pipelines and cloud integrations.",
    longDesc:
      "Mridul focuses on building scalable backend systems that automate and optimize lab workflows. With a knack for cloud infrastructure and clean coding practices, he ensures the systems powering Labops are agile and future-ready. He contributes heavily to API performance and deployment automation.",
    experienceYears: "2024",
  },
  {
    name: "Rishikesh Ghosh",
    position: "Frontend Engineer",
    img: rishikeshImg,
    modal: true,
    linkedInUrl: "https://www.linkedin.com/in/rishikesh-ghosh-9a226a230/",
    shortDesc:
      "Designs sleek UIs for labs, doctors & healthcare partners at Labops.",
    longDesc:
      "Rishikesh brings life to the Labops experience through thoughtful frontend engineering. He crafts modern, clean, and responsive interfaces that feel effortless yet powerful. From dashboards to real-time interaction systems, he ensures users love what they see — and trust what they use.",
    experienceYears: "20224",
  },
];

export const mentorMembers = [
  {
    name: "Amir Khan",
    position: "MARL VC",
    showLinkdin: true,
    img: tm1,
    linkedInUrl: "https://www.linkedin.com/in/amirkhan177/",
  },
  {
    name: "Prakash Goswami",
    position: "MARL VC",
    showLinkdin: true,
    img: tm2,
    linkedInUrl: "https://www.linkedin.com/in/pgoswami/",
  },
  {
    name: "Ashish Mehra",
    showLinkdin: true,
    position: "Tau Ventures",
    img: tm3,
    linkedInUrl: "https://www.linkedin.com/in/drashishmehra/",
  },

  // {
  //   name: "Brendan Maxwell",
  //   position: "Workday",
  //   img: tm4,
  //   linkedInUrl: "https://www.linkedin.com/in/brendanmaxwell/",
  // },
];
